import { render, staticRenderFns } from "./ResellerInvoiceListTable.vue?vue&type=template&id=2d4d5fc2"
import script from "./ResellerInvoiceListTable.vue?vue&type=script&lang=js"
export * from "./ResellerInvoiceListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports